import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, throwError } from 'rxjs';
import { AppSettings } from '../app-settings';

@Injectable({
  providedIn: 'root',
})
export class ReportsService {
  constructor(private http: HttpClient) {}

  //Obtener años y meses disponibles
  // reports.service.ts

  // Obtener años y meses disponibles con date_from opcional
  // En reports.service.ts
  getYearsMonths(idBusiness: number, dateFrom?: string, dateTo?: string, idSpace?: any) {
    let url = `${AppSettings.API_URI_V2}/reports/years-months?id_company=${idBusiness}`;

    if (dateFrom) {
      url += `&date_from=${dateFrom}`;
    }
    if (dateTo) {
      url += `&date_to=${dateTo}`;
    }
    if (idSpace && idSpace.length > 0) {
      const space = Array.isArray(idSpace) ? idSpace[0] : idSpace;
      url += `&id_space=${space}`;
    }

    return this.http.get<any>(url).pipe(
      map((data) => data),
      catchError((err) => throwError(() => err)),
    );
  }

  // Acciones globales
  getUrlsDownload(idOrder: number) {
    const url = `${AppSettings.API_URI_V2}/orders/${idOrder}/tickets-urls`;
    return this.http.get<any>(url).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        return throwError(() => err);
      }),
    );
  }

  // Acciones individuales
  cancelPendingOrder(idOrder: number) {
    const url = `${AppSettings.API_URI_V2}/cancel/pending/order/${idOrder}`;
    return this.http.patch<any>(url, { idOrder: idOrder }).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        return throwError(() => err);
      }),
    );
  }

  cancelOrder(isSuperAdmin: boolean, idOrder: any, payload: any) {
    const url = isSuperAdmin
      ? `${AppSettings.API_URI_V2}/admin/refund/order/${idOrder}`
      : `${AppSettings.API_URI_V2}/refund/order/${idOrder}`;
    return this.http.post<any>(url, payload).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        return throwError(() => err);
      }),
    );
  }

  getInfoTransaction(idOrder: number) {
    const url = `${AppSettings.API_URI_V2}/info/orders/${idOrder}/payment`;
    return this.http.get<any>(url).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        return throwError(() => err);
      }),
    );
  }

  sendEmailConfirm(idOrder: any, payload: any) {
    const url = `${AppSettings.API_URI_V2}/send/tickets/order/${idOrder}`;
    return this.http.post<any>(url, payload).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        return throwError(() => err);
      }),
    );
  }

  downloadReportFile(idBusiness: any, payload: any) {
    const baseUrl = `${AppSettings.API_URI_V2}/panel/download/reports/${idBusiness}`;
    /*const queryParams: string[] = [];

    // Orden específico de parámetros para coincidir con el backend
    const order = ['type', 'format', 'events', 'dates', 'method', 'reportsgroup', 'sessions','years','monthsByYear'];

    order.forEach(key => {
      if (!(key in payload)) return;

      const value = payload[key];

      // Omitir undefined y null
      if (value === undefined || value === null) {
        return;
      }

      if (Array.isArray(value)) {
        if (value.length === 0) {
          return; // No enviar arrays vacíos
        }
        // Para arrays: events[], method[], reportsgroup[]
        value.forEach(item => {
          const itemValue = item;
          queryParams.push(`${key}[]=${itemValue}`);
        });
      } else if (typeof value === 'object') {
        // Para objetos como dates: dates[date_from], dates[date_to]
        Object.keys(value).forEach(subKey => {
          const subValue = value[subKey];
          if (subValue !== null && subValue !== undefined) {
            queryParams.push(`${key}[${subKey}]=${subValue}`);
          }
        });
      } else {
        // Valores primitivos (type, format)
        queryParams.push(`${key}=${value}`);
      }
    });*/

    //const url = `${baseUrl}?${queryParams.join('&')}`;

    return this.http.post(baseUrl, payload, { responseType: 'text' }).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        return throwError(() => err);
      }),
    );
  }

  getHeaderReports() {
    const url = `${AppSettings.API_URI_V2}/admin/report/column-groups`;
    return this.http.get<any>(url).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        return throwError(() => err);
      }),
    );
  }

  sendTicketsMethod(selected: string, payload: any) {
    const method = selected == 'phone' ? 'sms' : 'email';
    const url = `${AppSettings.API_URI}/totem/tickets/send/${method}`;
    return this.http.post<any>(url, payload).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        return throwError(() => err);
      }),
    );
  }

  sendWhatsappMessage(payload: any) {
    const url = `${AppSettings.API_URI_V2}/tickets/send/whatsapp`;
    return this.http.post<any>(url, payload).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        return throwError(() => err);
      }),
    );
  }

  /**
   * El listado de "Mis entradas". `filters` acepta scope (upcoming|past),
   * search, event_from, event_to, bought_from y bought_to (todos en Y-m-d) y
   * refund (all|without|only). La respuesta trae, además de la página, un
   * `counts` con el total de cada pestaña ya filtrado.
   */
  getOrdersByUser(page: number, items: number, filters: any = {}) {
    let params = new HttpParams().set('page', page).set('per_page', items);

    Object.keys(filters).forEach((key) => {
      const value = filters[key];
      if (value !== null && value !== undefined && value !== '') {
        params = params.set(key, value);
      }
    });

    const url = `${AppSettings.API_URI_V2}/user/orders`;
    return this.http.get<any>(url, { params }).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        return throwError(() => err);
      }),
    );
  }

  /**
   * Un pedido suelto del propio usuario, para la pantalla de la entrada.
   */
  getOrderByUser(idOrder: number) {
    const url = `${AppSettings.API_URI_V2}/user/orders/${idOrder}`;
    return this.http.get<any>(url).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        return throwError(() => err);
      }),
    );
  }

  /**
   * El pedido del banner "Tu próximo plan". Devuelve { order: null } cuando
   * el usuario no tiene nada por delante.
   */
  getNextEventByUser() {
    const url = `${AppSettings.API_URI_V2}/user/next-event`;
    return this.http.get<any>(url).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        return throwError(() => err);
      }),
    );
  }

  /**
   * Enlace "Añadir a Google Wallet" de UNA entrada. El backend devuelve
   * `data.save_url` con la URL de guardado (JWT firmado). Un 503 significa que
   * Wallet aún no está configurado en el servidor.
   *
   * Va por `booking` y no por pedido: cada entrada tiene su hash y su QR, y el
   * pase es de una. Eso lo separa de la descarga del PDF, que sí es por pedido.
   */
  getGoogleWalletUrl(idBooking: number) {
    const url = `${AppSettings.API_URI_V2}/bookings/${idBooking}/wallet/google`;
    return this.http.get<any>(url).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        return throwError(() => err);
      }),
    );
  }

  /**
   * Equivalente de Apple. Devuelve `data.download_url`: una URL firmada de vida
   * corta que sirve el `.pkpass`. No se puede pedir el fichero por aquí — iOS
   * solo abre Wallet si llega por una navegación del navegador, que no lleva el
   * Bearer —, así que quien llame tiene que navegar a esa URL.
   */
  /**
   * Google Wallet con TODAS las entradas de un evento de un pedido, de una
   * vez: un pase por entrada, que Wallet enseña apilados. Sin tope; con
   * muchas puede tardar unos segundos.
   */
  getGoogleWalletUrlForEvent(idOrder: number, idEvent: number, idSession: number | null) {
    const url = `${AppSettings.API_URI_V2}/orders/${idOrder}/wallet/google`;
    const params: any = { event: idEvent };
    if (idSession) {
      params.session = idSession;
    }
    return this.http.get<any>(url, { params }).pipe(
      map((data) => data),
      catchError((err) => throwError(() => err)),
    );
  }

  /** Lo mismo para Apple: `data.download_url` sirve un `.pkpasses`. */
  getAppleWalletUrlForEvent(idOrder: number, idEvent: number, idSession: number | null) {
    const url = `${AppSettings.API_URI_V2}/orders/${idOrder}/wallet/apple`;
    const params: any = { event: idEvent };
    if (idSession) {
      params.session = idSession;
    }
    return this.http.get<any>(url, { params }).pipe(
      map((data) => data),
      catchError((err) => throwError(() => err)),
    );
  }

  getAppleWalletUrl(idBooking: number) {
    const url = `${AppSettings.API_URI_V2}/bookings/${idBooking}/wallet/apple`;
    return this.http.get<any>(url).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        return throwError(() => err);
      }),
    );
  }
}
